import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@stockx/ui';
import { ChevronLeftIcon, ChevronRightIcon } from '@stockx/icons';
import { BigButtonStyles, ButtonStyles } from '../styles/Carousel.styles';
import { ButtonProps } from '../types';

const SharedCarouselButton: React.FC<ButtonProps> = ({
  isBig = false,
  isExtendedHomepageCarousel = false,
  onClick,
  position,
  isDisabled,
}) => {
  const { t } = useTranslation();
  const iconSettings = { color: 'white', 'aria-hidden': true };

  const icon =
    position === 'left' ? (
      <ChevronLeftIcon {...iconSettings} />
    ) : (
      <ChevronRightIcon {...iconSettings} />
    );

  const carouselButtonStyles = useMemo(() => {
    if (isBig) {
      return BigButtonStyles[position];
    }

    if (isExtendedHomepageCarousel) {
      return {
        ...BigButtonStyles[position],
        display: 'none',
        // Custom query needed here for non-standard horizontal overflow point on product collections
        '@media (min-width: 1226px)': {
          display: 'inline-flex',
        },
      };
    }

    return ButtonStyles[position];
  }, [isBig, isExtendedHomepageCarousel]);

  return (
    <IconButton
      aria-label={t(`Move carousel ${position}`)}
      // @ts-expect-error ts-migrate(2322) FIXME: Type '"icon"' is not assignable to type '"sm" | "l... Remove this comment to see the full error message
      size="icon"
      variant="primary"
      sx={carouselButtonStyles}
      onClick={onClick}
      icon={icon}
      isDisabled={isDisabled}
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'false | "default !important"' is not assigna... Remove this comment to see the full error message
      cursor={isDisabled && 'default !important'}
      isRound
      className="icon-button"
    />
  );
};

export default SharedCarouselButton;
